import { ReactNode } from "react";
import "./main-container.css";
import { useAppContext } from "../../../AppContext";
import CloseIcon from "../../svgs/closeIcon";

export const MainContainer = ({ children }: { children: ReactNode }) => {
  const { dispatch, showModal } = useAppContext();
  const closeModal = () => {
    dispatch({
      type: "UPDATE_CONTEXT",
      payload: {
        showModal: !showModal,
      },
    });
  };
  return (
    <div className="main-app-modal-overlay">
      <div
        style={{
          position: "fixed",
          left: "94%",
          top: "2%",
        }}
      >
        <CloseIcon onClick={() => closeModal()} />
      </div>
      <div style={{ textAlign: "center" }}>
        <img
          src="https://smartpos.ie/wp-content/uploads/2024/03/npixsp-fcolour.png"
          alt="smartpos + npi"
          className="main-logo"
        />
      </div>
      {children}
    </div>
  );
};
